export default __webpack_public_path__ + "static/cashless-payment-solution-for-events-and-conferences-c862accb06760cb69d531b3daf67e085.png";